import {setup} from "./modules/HgBoot";
import ReactDOM from "react-dom";
import React from "react";
import HgCake from "./cake/HgCake";


setup('HgCake', function(initialState, container, cb) {
    ReactDOM.render(<HgCake {...initialState} />,
        document.getElementById(container),
        cb
    );
});


// WEBPACK FOOTER //
// ./js/HgCake.js